import React, { useReducer } from 'react';
import clienteAxios from '../../config/axios';

import ExperienciasContext from './experienciasContext';
import ExperienciasReducer from './experienciasReducer';

import {
    GET_INFO_EXPERIENCIAS,
    EDITAR_EXPERIENCIAS,
    GET_INFO_ERROR
} from '../../types';
import clienteAxios2 from '../../config/axiosUpload';

const ExperienciasState = props => {

    const initialState = {
        banner: null,
        slider: null,
        section1: null
    }
    const [state, dispatch] = useReducer(ExperienciasReducer, initialState);

    const getExperiencias = async () => {
        try {
            const respuesta = await clienteAxios.get(`/experiencias`);
            dispatch({
                type: GET_INFO_EXPERIENCIAS,
                payload: respuesta.data.data
            })
        } catch (error) {
            dispatch({
                type: GET_INFO_ERROR,
                payload: error.response.data.msg
            })
        }
    }

    const updateExperiencias = async (file, newData) => {
        let data = {
            banner: state.banner,
            slider: state.slider,
            section1: state.section1
        }

        data = {...data, ...newData};
        // console.log(data);
        file.append("data", JSON.stringify(data));
        file.append("ruta", "experiencias");

        try {
            const respuesta = await clienteAxios.put(`/experiencias`, file);
            const respuesta2 = await clienteAxios2.post(`/upload`, file);

            // console.log(respuesta)
            dispatch({
                type: EDITAR_EXPERIENCIAS,
                payload: respuesta.data
            })
        } catch (error) {
            console.log(error)
        }
    }
    
    return (
        <ExperienciasContext.Provider
            value={{
                banner: state.banner,
                slider: state.slider,
                section1: state.section1,
                getExperiencias,
                updateExperiencias,
            }}
        >
            {props.children}
        </ExperienciasContext.Provider>
    )
}

export default ExperienciasState;